module.exports = __webpack_public_path__ + "img/photo2.6a58eb0b.jpg";